import {
    SuccessFeedbackScreen,
    ButtonPrimary,
    skinVars,
    useWindowSize,
    ErrorFeedbackScreen,
} from '@telefonica/mistica';
import { t } from 'i18next';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import { useConfigureLineContext } from '../../../../utils/store/context/configure-line-context/ConfigureLineContext';

const FeedBackDuplicateSim = () => {
    const navigate = useNavigate();
    const size = useWindowSize();
    const { simTypeSelected, duplicateSimSuccess, configureLineError, setConfigureLineError, setSimTypeSelected } =
        useConfigureLineContext();

    const naigateHome = () => {
        navigate(`/home`);
        setSimTypeSelected('PHYSICAL_SIM');
        setConfigureLineError(null);
    };

    return (
        <div
            className='feedbackDuplicateSim'
            style={{
                background: duplicateSimSuccess
                    ? size.width < 1024 || size.height < 550
                        ? skinVars.colors.backgroundBrand
                        : ''
                    : skinVars.colors.background,
            }}
        >
            <>
                {duplicateSimSuccess && (
                    <SuccessFeedbackScreen
                        title={
                            simTypeSelected === 'PHYSICAL_SIM'
                                ? t('contactVerificationSuccessTitle')
                                : t('eSimFeedbackSuccessTitle')
                        }
                        description={
                            simTypeSelected === 'PHYSICAL_SIM' ? t('simFeedbackSuccess') : t('esimFeedbackSuccess')
                        }
                        primaryButton={
                            <ButtonPrimary onPress={naigateHome}>{t('calldivertalerttextbtn')}</ButtonPrimary>
                        }
                    />
                )}
                {!duplicateSimSuccess && (
                    <ErrorFeedbackScreen
                        title={t('supportErrorFeedbackErrorOccurredTitle')}
                        description={t('profileFeedbackErrorSubtitle')}
                        errorReference={
                            configureLineError?.response?.status
                                ? `${t('feedbackCodeError')} ${configureLineError?.response?.status}`
                                : ''
                        }
                        primaryButton={
                            <ButtonPrimary onPress={naigateHome}>{t('calldivertalerttextbtn')}</ButtonPrimary>
                        }
                    />
                )}
            </>
        </div>
    );
};

export default FeedBackDuplicateSim;
